import { CommonModule } from "@angular/common";
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
//import { DragulaModule } from 'ng2-dragula';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { LunaCommonModule } from "../common/common.module";
import { EmptyDataConfigComponent } from "./components/state/controls/config/data/empty-data-config.component";
import { MultiselectDataConfigComponent } from "./components/state/controls/config/data/multiselect-data-config.component";
import { EmptyDisplayConfigComponent } from "./components/state/controls/config/display/empty-display-config.component";
import { MultiselectDisplayConfigComponent } from "./components/state/controls/config/display/multiselect-display-config.component";
import { TextualDisplayConfigComponent } from "./components/state/controls/config/display/textual-display-config.component";
import { BooleanDisplayConfigComponent } from "./components/state/controls/config/display/boolean-display-config.component";
import { PdfGeneratorDisplayConfigComponent } from "./components/state/controls/config/display/pdf-generator-display-config.component";
import { CasingPlanDataConfigComponent } from "./components/state/controls/config/data/well-related/casing-plan-data-config.component";
import { MapControlDataConfigComponent } from "./components/state/controls/config/data/well-related/map-control-data-config.component";
import { AreaOfReviewMapControlDataConfigComponent } from "./components/state/controls/config/data/well-related/area-of-review-map-control-data-config.component";
import { StateBuilderDataComponent } from './components/state/state-builder-data.component';
import { StateBuilderDndComponent } from "./components/state/state-builder-dnd.component";
import { StateBuilderOutlineComponent } from "./components/state/state-builder-outline.component";
import { StateBuilderPageComponent } from "./components/state/state-builder-page.component";
import { StateBuilderPageButtonsComponent } from "./components/state/state-builder-page-buttons.component";
import { StateBuilderRulesComponent } from "./components/state/state-builder-rules.component";
import { StateBuilderSettingsComponent } from './components/state/state-builder-settings.component';
import { StateBuilderValidationComponent } from './components/state/state-builder-validation.component';
import { StateBuilderComponent } from "./components/state/state-builder.component";
import { WorkflowBuilderComponent } from "./components/workflow/workflow-builder.component";
import { WorkflowBuilderTabsComponent } from "./components/workflow/workflow-builder-tabs.component";
import { WorkflowContextComponent } from "./components/workflow/workflow-context.component";
import { WorkflowContextTreeComponent } from "./components/workflow/workflow-context-tree.component";
import { WorkflowContextLeafComponent } from "./components/workflow/workflow-context-leaf.component";
import { WorkflowEntityComponent } from "./components/workflow/workflow-entity.component";
import { WorkflowEntityAtlasComponent } from "./components/workflow/workflow-entity-atlas.component";
import { WorkflowEntityMapComponent } from "./components/workflow/workflow-entity-map.component";
import { WorkflowDiagramComponent } from "./components/workflow/workflow-diagram.component";
import { WorkflowDiagramFormEditorComponent } from "./components/workflow/workflow-diagram-form-editor.component";
import { WorkflowTransitionEditorComponent } from "./components/workflow/workflow-transition-editor.component";
import { FlowTemplateResolver } from "./resolvers/flow-template.resolver";
import { EntityDefinitionService } from "./services/entity-definition.service";
import { FlowTemplateService } from "./services/flow-template.service";
import { EntityBuilderService } from "./services/entity-builder.service";
import { GoItemFactoryService } from "./services/go-item-factory.service";
import { RuleBuilderService } from "./services/rule-builder.service";
import { EmailConfigService } from "./services/email-config.service";
import { StateBuilderService } from "./services/state-builder.service";
import { FormControlsModule } from '../form-controls/form-controls.module';
import { RadioDataConfigComponent } from './components/state/controls/config/data/radio-data-config.component';
import { RadioDisplayConfigComponent } from './components/state/controls/config/display/radio-display-config.component';
import { ButtonLinkDataConfigComponent } from './components/state/controls/config/data/button-link-data-config.component';
import { ESignatureDisplayConfigComponent } from './components/state/controls/config/display/e-signature-display-config.component';
import { BaseGuardService } from "../auth/guards/base-guard.service";
import { StateBuilderSectionValidationComponent } from './components/state/state-builder-section-validation.component';
import { WorkflowDiagramEndEditorComponent } from './components/workflow/workflow-diagram-end-editor.component';
import { FileUploadDataConfigComponent } from './components/state/controls/config/data/fileupload-data-config.component';
import { ReportTemplateEditorDataConfigComponent } from './components/state/controls/config/data/report-template-editor-data-config.component';
import { BuilderService } from "./services/builder.service";
import { DataTableConfigModule } from "./components/state/controls/config/data/data-table-config/data-table-config.module";
import { DataQueryButtonConfigModule } from "./components/state/controls/config/data/data-query-button-config.module";
import { CommonConfigModule } from "./components/state/controls/config/common/common.module";
import { PaymentCheckoutDataConfigComponent } from './components/state/controls/config/data/payment-checkout-data-config.component';
import { PaymentResponseDataConfigComponent } from './components/state/controls/config/data/payment-response-data-config.component';
import { FlowPdfViewerDataConfigComponent } from './components/state/controls/config/data/flow-pdf-viewer-data-config.component';
import { WorkflowImportComponent } from './components/workflow/workflow-import.component';
import { SideEffectsModule } from "./components/workflow/sideeffects/side-effects.module";
import { WorkflowEntityImportComponent } from './components/workflow/workflow-entity-import.component';
import { ExpressionTestComponent } from './components/expression-test/expression-test.component';
import { AccordionModule } from "../common/components/accordion/accordion.module";
import { LayerManagerComponent } from "./components/state/controls/config/data/well-related/gis-map/layer-manager/layer-manager.component";
import { PropertySelectorModule } from "./components/state/controls/config/data/data-table-config/column-mapper/column-item/property-selector/property-selector.module";
import { LayerComponent } from "./components/state/controls/config/data/well-related/gis-map/layer-manager/layer/layer.component";
import { WidgetManagerComponent } from "./components/state/controls/config/data/well-related/gis-map/widget-manager/widget-manager.component";
import { WidgetComponent } from "./components/state/controls/config/data/well-related/gis-map/widget-manager/widget/widget.component";
import { DropdownSelectButtonModule } from "../common/components/dropdown-select-button/dropdown-select-button.module";
import { GeometryManagerComponent } from "./components/state/controls/config/data/well-related/gis-map/geometry-manager/geometry-manager.component";
import { RICSMenuModule } from "../common/components/menu/menu.module";
import { GeometricLayerComponent } from "./components/state/controls/config/data/well-related/gis-map/geometry-manager/geometric-layer/geometric-layer.component";
import { GeometryItemComponent } from "./components/state/controls/config/data/well-related/gis-map/geometry-manager/geometry-item/geometry-item.component";
import { PointConfigurationComponent } from "./components/state/controls/config/data/well-related/gis-map/geometry-manager/point-configuration/point-configuration.component";
import { PolylineConfigurationComponent } from "./components/state/controls/config/data/well-related/gis-map/geometry-manager/polyline-configuration/polyline-configuration.component";
import { DatePickerDataConfigComponent } from "./components/state/controls/config/data/datepicker-data-config.component";
import { FileUploadDisplayConfigComponent } from './components/state/controls/config/display/file-upload-display-config.component';
import { ReportPdfViewerDataConfigComponent } from './components/state/controls/config/data/report-pdf-viewer-data-config.component';
import { CasingPlanGridDataConfigComponent } from "./components/state/controls/config/data/well-related/casing-plan-grid/casing-plan-grid-data-config.component";
import { DomainDefinitionService } from "./services/domain-definition.service";
import { ListEntryDisplayConfigComponent } from './components/state/controls/config/display/listentry-display-config.component';
import { StateBuilderButtonPermissionsComponent } from './components/state/state-builder-button-permissions/state-builder-button-permissions.component';
import { OnBaseFileUploadDataConfigComponent } from './components/state/controls/config/data/onbase-file-upload-data-config.component';
import { CasingPlanSchematicDataConfigComponent } from './components/state/controls/config/data/well-related/casing-plan-schematic-data-config.component';
import { CasingPlanSchematicDisplayConfigComponent } from './components/state/controls/config/display/casing-plan-schematic-display-config.component';
import { FileParserDataConfigComponent } from "./components/state/controls/config/data/file-parser-config/fileparser-data-config.component";
import { EntityPropertyComponent } from './components/state/controls/config/data/file-parser-config/entity-property/entity-property.component';
import { ParserFormatDisplayComponent } from './components/state/controls/config/data/file-parser-config/parser-format-display/parser-format-display.component';
import { BulkWellTransferParserDataConfigComponent } from './components/state/controls/config/data/bulk-well-transfer-parser-data-config/bulk-well-transfer-parser-data-config.component';


@NgModule({ declarations: [
        WorkflowBuilderComponent,
        LayerComponent,
        WorkflowBuilderTabsComponent,
        WorkflowContextComponent,
        WorkflowContextTreeComponent,
        WorkflowContextLeafComponent,
        WorkflowEntityComponent,
        WorkflowEntityAtlasComponent,
        WorkflowEntityMapComponent,
        WorkflowDiagramComponent,
        WorkflowDiagramFormEditorComponent,
        WorkflowTransitionEditorComponent,
        StateBuilderComponent,
        StateBuilderDndComponent,
        StateBuilderPageComponent,
        StateBuilderPageButtonsComponent,
        StateBuilderRulesComponent,
        StateBuilderOutlineComponent,
        StateBuilderSettingsComponent,
        StateBuilderValidationComponent,
        StateBuilderDataComponent,
        MultiselectDataConfigComponent,
        MultiselectDisplayConfigComponent,
        EmptyDataConfigComponent,
        EmptyDisplayConfigComponent,
        TextualDisplayConfigComponent,
        BooleanDisplayConfigComponent,
        PdfGeneratorDisplayConfigComponent,
        RadioDataConfigComponent,
        RadioDisplayConfigComponent,
        ButtonLinkDataConfigComponent,
        ESignatureDisplayConfigComponent,
        StateBuilderSectionValidationComponent,
        WorkflowDiagramEndEditorComponent,
        FileUploadDataConfigComponent,
        ReportTemplateEditorDataConfigComponent,
        PaymentCheckoutDataConfigComponent,
        PaymentResponseDataConfigComponent,
        WorkflowImportComponent,
        CasingPlanDataConfigComponent,
        CasingPlanGridDataConfigComponent,
        MapControlDataConfigComponent,
        AreaOfReviewMapControlDataConfigComponent,
        FlowPdfViewerDataConfigComponent,
        WorkflowEntityImportComponent,
        ExpressionTestComponent,
        LayerManagerComponent,
        WidgetManagerComponent,
        GeometryManagerComponent,
        WidgetComponent,
        GeometricLayerComponent,
        GeometryItemComponent,
        PointConfigurationComponent,
        PolylineConfigurationComponent,
        DatePickerDataConfigComponent,
        FileUploadDisplayConfigComponent,
        ReportPdfViewerDataConfigComponent,
        ListEntryDisplayConfigComponent,
        StateBuilderButtonPermissionsComponent,
        OnBaseFileUploadDataConfigComponent,
        CasingPlanSchematicDataConfigComponent,
        CasingPlanSchematicDisplayConfigComponent,
        FileParserDataConfigComponent,
        EntityPropertyComponent,
        ParserFormatDisplayComponent,
        BulkWellTransferParserDataConfigComponent
], imports: [
		CommonModule,
        LunaCommonModule,
        PropertySelectorModule,
        DataQueryButtonConfigModule,
        DropdownSelectButtonModule,
        AccordionModule,
        FormsModule,
        RICSMenuModule,
        ReactiveFormsModule,
        SideEffectsModule,
        CommonConfigModule,
	//DragulaModule,
		DragDropModule,
        DataTableConfigModule,
        FormControlsModule], providers: [
        BaseGuardService,
        EntityDefinitionService,
        FlowTemplateService,
        FlowTemplateResolver,
        GoItemFactoryService,
        HttpClient,
        RuleBuilderService,
        StateBuilderService,
        EntityBuilderService,
        EmailConfigService,
        BuilderService,
        DomainDefinitionService,
        provideHttpClient(withInterceptorsFromDi())
    ] })

export class LunaBuilderModule { }
